export const YOUTUBE_CHANNEL =
  "https://www.youtube.com/channel/UCitrOi2Xi4YbsYZ9PUfXuPg"

export const TIKTOK_CHANNEL = "https://www.tiktok.com/@huyposter"

export const MESSENGER = "https://www.messenger.com/t/doanhuyposter/"
